function initMomentsSlider() {

    $('.recipes-container .moments-slider-images').on('init afterChange', function (event, slick, direction) {
        $(this).find('.slick-slide').removeClass('last-active');
        $(this).find('.slick-active').last().addClass('last-active');
    });

    initSlick('.news-container');
    initSlick('.recipes-container');
}

function initSlick(containerSelector) {

    var navFor = containerSelector + ' .moments-slider-contents';
    $(containerSelector + ' .moments-slider-images').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        draggable: true,
        fade: false,
        asNavFor: navFor,
        adaptiveHeight: true,
        responsive:
            [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        draggable: true,
                        fade: false,
                        asNavFor: navFor,
                        adaptiveHeight: true,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        draggable: true,
                        fade: false,
                        asNavFor: navFor,
                        adaptiveHeight: true,
                    }
                }
            ]
    });

    navFor = containerSelector + ' .moments-slider-images';
    $(containerSelector + ' .moments-slider-contents').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: true,
        centerMode: true,
        infinite: true,
        fade: true,
        asNavFor: navFor
    });
}
